export default __webpack_public_path__ + "static/media/syringe.73291405.svg";